// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2rdfc","savePackageButton":"ClientWallet_savePackageButton__2z3Ug"};